import React from "react";
import { Divider } from "@material-ui/core";

const SectionDivider = () => (
  <div style={{ width: "100%" }}>
    <Divider style={{ background: "var(--borderColor)" }} />
  </div>
)

export default SectionDivider;
